import { render } from "./WalletSummary.vue?vue&type=template&id=5961d624&scoped=true"
import script from "./WalletSummary.vue?vue&type=script&lang=js"
export * from "./WalletSummary.vue?vue&type=script&lang=js"

import "./WalletSummary.vue?vue&type=style&index=0&id=5961d624&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5961d624"]])

export default __exports__